var _path, _circle, _path2, _circle2, _path3, _circle3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuantity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3.5L16 3.5V4.5L1 4.5V3.5Z",
    fill: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.09375,
    cy: 4.01562,
    r: 1.65625,
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 7.5L16 7.5V8.5L1 8.5V7.5Z",
    fill: "#333333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.7812,
    cy: 8,
    r: 1.65625,
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 11.5L16 11.5V12.5L1 12.5V11.5Z",
    fill: "#333333"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.21875,
    cy: 11.9844,
    r: 1.65625,
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 2,
    stroke: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantity);
export default __webpack_public_path__ + "static/media/quantity.ce71f1785ec3e28b2ee7be9ecf19cde9.svg";
export { ForwardRef as ReactComponent };